import retrieveDaqsJson from './retrieve-daqs-json'
import tableAdapter from './tableAdapter'
import boatBins from './filters/boatBins'
import { components } from '@datavue/datavue-ui'
import states from './filters/statesSafetyOther'
const ChloroplethHeatmap = () =>
  import('../components/charts/ChloroplethHeatmap')
const HorizontalBarchart = () =>
  import('../components/charts/HorizontalBarchart')
const GenericPage = () => import('@/components/pages/GenericPage')
const DaqsChart = () => import('@/components/DaqsChart')
export default class SafetyOther {
  title = 'Boating Safety'
  key = 'safety_other'
  pageComponent = GenericPage
  retrieveData = retrieveDaqsJson
  filters = function () {
    return {
      question: {
        key: 'question',
        label: 'View results for the question:',
        component: components['DatavueUiSelect'],
        options: [
          {
            key: 'epirb',
            label: 'Was an EPIRB on board?',
            default: true
          },
          {
            key: 'plb',
            label: 'Was a PLB on board?'
          }
        ]
      },
      filter1boatbin: {
        label: 'Boat Category:',
        component: components['DatavueUiSelect'],
        options: boatBins
      },
      filter2state: {
        label: 'State of Operation:',
        component: components['DatavueUiSelect'],
        options: states
      },
      measure: {
        label: 'Display results as:',
        component: components['DatavueUiRadioGroup'],
        props: {
          inline: true
        },
        options: [
          {
            key: 'count',
            label: 'Number (In 100s)',
            default: true
          },
          {
            key: 'percent',
            label: 'Percent'
          }
        ]
      }
    }
  }
  charts = function () {
    return {
      overall_allboats: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore And Answered Yes',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      overall_operated: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: {},
          grid: 'overall'
        }
      },
      state_allboats: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore And Answered Yes By State',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'Boats That Went Over 3 Nautical Miles From Shore And Answered Yes By State',
          tableAdapter: tableAdapter
        }
      },
      state_operated: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore By State',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: ChloroplethHeatmap,
          mapType: 'state',
          grid: 'map',
          tableLabel: 'Boats That Went Over 3 Nautical Miles From Shore By State',
          tableAdapter: tableAdapter
        }
      },
      boatbin_allboats: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore And Answered Yes By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Boat Category',
          tableAdapter: tableAdapter
        }
      },
      boatbin_operated: {
        title: 'Boats That Went Over 3 Nautical Miles From Shore By Boat Category',
        component: DaqsChart,
        props: {
          card: false,
          chartComponent: HorizontalBarchart,
          grid: 'other',
          tableLabel: 'Boat Category',
          tableAdapter: tableAdapter
        }
      }
    }
  }
}
